<template>
  <side-base>
    <div class="swrap">
      <div class="shead">
        <search-filter
          :enableLeft="false"
          :enableCampus="false"
          :start="params.startTime | formatDatetime('yyyy-MM-dd')"
          :end="params.endTime | formatDatetime('yyyy-MM-dd')"
          @search="params.studentName = $event"
          placeholder="请输入学员姓名"
          :enableSearch="true"
          :hasFilter="true"
          @clickFilter="openFilter"
          @clickDate="chooseCalendar"
          class="filter"
        />
      </div>
      <vx-list class="smain" enable :api="api" :params="listParams" @load="onLoad">
        <div class="items-wrapper">
          <div
            class="item-wrapper van-hairline--bottom"
            v-for="item in listAll"
            :key="item.id"
            @click="checkboxClickHandler(item)"
          >
            <div class="content">
              <div class="l1 normal van-ellipsis has-checked">
                <side-icon-select :checked="ids.includes(item.id)" />
                <span>{{ item.studentName }}</span>
              </div>
              <div class="l2">
                <div class="van-ellipsis" v-if="item.coursePlanType === 0">
                  {{ item.className }}
                </div>
                <div class="van-ellipsis" v-else>
                  {{ item.curriculumName }}
                </div>
              </div>
              <div class="l2 van-ellipsis">
                <span>{{ item.courseStartTime | formatDatetime('MM月dd日') }}</span>
                <span>({{ weekDays[item.courseWeekday || 1] }})&ensp;</span>
                <span
                  >{{ item.courseStartTime | formatDatetime('hh:mm') }}～{{
                    item.courseEndTime | formatDatetime('hh:mm')
                  }}</span
                >
                <span>&ensp;{{ absentTips[item.absentStatus] }}</span>
              </div>
            </div>
          </div>
        </div>
        <van-empty
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          v-if="listAll.length === 0 && !loading"
          description="没有找到缺勤记录"
          style="text-align: center"
          image-size="128"
        >
        </van-empty>
      </vx-list>
      <side-foot
        @cancel="close"
        @confirm="confirm(getRet())"
        :confirmSubText="config.radio ? '' : `(${list.length})`"
      />
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';
import SearchFilter from '@x3/vue/comp/search-filter.vue';
import { openMakeUpFiltrate } from '@teacher/views/base/make-up/filtrate/index.js';

function getInitParams() {
  return {
    // 校区ID集合
    campusIds: [],
    startTime: app.tool.date.getBasedOnToDayDate(-7),
    endTime: new Date(),
    curriculumId: '',
    curriculumName: '',
    studentName: '',
    classId: '',
    className: '',
    remedyStatusList: [0],
    type: 2,
    status: [1],
    courseRelations: [],
  };
}

export default {
  name: 'x3-side-absent-log',
  mixins: [sideMixin],
  components: {
    SearchFilter,
  },
  data() {
    return {
      pageTitle: '选择缺勤记录',
      params: getInitParams(),
      list: [],
      api: this.$api.courseAbsentList,
      loading: false,
      weekDays: ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      absentTips: ['', '', '', '请假', '未到'],
    };
  },
  computed: {
    listParams: function () {
      return Object.assign({}, this.params, {
        startTime: app.tool.date.formatDatetime(this.params.startTime, 'yyyy-MM-dd'),
        endTime: app.tool.date.formatDatetime(this.params.endTime, 'yyyy-MM-dd'),
      });
    },
  },
  methods: {
    onLoad(list, res) {
      this.listAll = list;
      this.total = res.page.totalCount;
      let rawIds = this.ids;
      if (rawIds && rawIds.length) {
        this.list.forEach(v => {
          if (rawIds.includes(v.id)) {
            this.choosedStudentObj[v.studentId] = true;
          }
        });
      }
    },
    // 打开筛选
    async openFilter() {
      let res = await openMakeUpFiltrate({
        params: {
          ...this.listParams,
          campusList: this.campusList,
        },
        config: {
          disableCampus: true,
          disableStatus: true,
          disableCourse: true,
          enableTagFilter: true,
        },
      });
      this.params.startTime = res.params.startTime;
      this.params.endTime = res.params.endTime;
      this.params.classId = res.params.classId;
      this.params.className = res.params.className;
      this.params.status = res.params.status;
      this.params.courseRelations = res.params.courseRelations;
    },
    // 显示日期选择框
    chooseCalendar() {
      app.x3.picker
        .dateRange({
          startDate: new Date(this.params.startTime),
          endDate: new Date(this.params.endTime),
          attrs: {
            allowSameDay: true,
            // maxDate: new Date(),
            // maxRange: '',
            // minDate: app.tool.date.getBasedOnToDayDate(-1, 'FullYear'),
          },
        })
        .then(res => {
          this.params.startTime = res.startDate;
          this.params.endTime = res.endDate;
        })
        .catch(() => {
          console.log('取消选择或报错了');
        });
    },
    checkboxClickHandler(item) {
      // 已选中同学员的缺勤记录，不可再继续选中同名学员；
      if (item.studentId && this.choosedStudentObj[item.studentId] && !this.ids.includes(item.id)) {
        this.$toast(`请勿重复选择${item.studentName || '同一'}学员缺勤记录`);
        return false;
      }

      let idx = 0;
      if (!this.config.radio) {
        idx = this.ids.indexOf(item.id);
      }

      if (this.ids.includes(item.id)) {
        this.ids.splice(idx, 1);
        this.list.splice(idx, 1);
      } else {
        this.ids.push(item.id);
        this.list.push(item);
      }
      this.choosedStudentObj[item.studentId] = this.ids.includes(item.id);
    },
  },
  created() {
    this.choosedStudentObj = {};
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .smain {
    flex: 1;
    overflow: auto;
    .items-wrapper {
      padding: 0 calc(var(--gap) * 16);
      background: var(--white);
    }
    .item-wrapper {
      display: flex;
      align-items: center;

      padding: calc(var(--gap) * 12) 0 calc(var(--gap) * 12);
      color: var(--g6);
      overflow: hidden;
      .content {
        flex: 1;
        overflow: hidden;
        .has-checked {
          position: relative;
          padding-left: calc(var(--gap) * 28);
          > i {
            position: absolute;
            left: 0;
            top: 50%;
            width: calc(var(--w) * 18);
            height: calc(var(--w) * 18);
            transform: translateY(-50%);
          }
        }
        .l1 {
          font-size: 24px;
          line-height: 30px;
          font-weight: var(--bold);
          color: var(--g8);
          &.is-late {
            color: var(--g5);
          }
          &.normal {
            font-size: var(--fs-ex1);
            line-height: var(--lh-ex1);
          }
        }
        .l2 {
          padding-left: calc(var(--gap) * 28);
          margin-top: calc(var(--gap) * 8);
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g6);
          display: flex;
          align-items: center;
          &.has-middle-point {
            &::before {
              margin-right: calc(var(--gap) * 8);
              content: '';
              display: inline-block;
              width: calc(var(--w) * 6);
              height: calc(var(--w) * 6);
              background-color: var(--c1);
              border-radius: 50%;
            }
          }
        }
      }
      .btns-nav {
        margin: 0 calc(var(--gap) * 7);
        width: calc(var(--w) * 86);
        > button {
          padding: 0 calc(var(--gap) * 12);
        }
      }
    }
  }
}
</style>